import { useEffect, useState } from 'react';
import { apiFetch } from '../store';

export function useLegalDocuments() {
  const [bundle, setBundle] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let active = true;
    setBundle(null);
    setError('');
    apiFetch('/auth/legal-documents').then(async (res) => {
      if (!res.ok) throw new Error();
      const data = await res.json();
      if (active) setBundle(data);
    }).catch(() => { if (active) setError('Не удалось загрузить документы. Попробуйте ещё раз.'); });
    return () => { active = false; };
  }, [attempt]);
  return { bundle, error, retry: () => setAttempt((n) => n + 1) };
}

export function LegalDocumentText({ document, bundle }) {
  return <div style={{ lineHeight: 1.6, fontSize: 14, overflowWrap: 'anywhere' }}>
    <p>Редакция: {document.version}. {bundle.operator}</p>
    {document.sections.map((section) => <section key={section.title}>
      <h3>{section.title}</h3>
      {section.body.map((block, i) => Array.isArray(block)
        ? <ul key={i}>{block.map((item, j) => <li key={j}>{item}</li>)}</ul>
        : <p key={i}>{block}</p>)}
    </section>)}
    <p>{bundle.contact}</p>
  </div>;
}

export default function LegalAcceptance({ onChange }) {
  const { bundle, error, retry } = useLegalDocuments();
  const [checked, setChecked] = useState({});
  useEffect(() => {
    const ready = bundle && bundle.documents.every((doc) => checked[doc.kind] === true);
    onChange(ready ? Object.fromEntries(bundle.documents.map((doc) => [doc.kind, {
      accepted: true, version: doc.version, sha256: doc.sha256,
    }])) : null);
  }, [bundle, checked, onChange]);
  if (error) return <div role="alert">{error} <button type="button" onClick={retry}>Повторить</button></div>;
  if (!bundle) return <p role="status">Загружаем документы…</p>;
  return <div className="col gap-3">
    {bundle.documents.map((doc) => <div key={doc.kind}>
      <details style={{ marginBottom: 8 }}>
        <summary style={{ cursor: 'pointer', color: 'var(--accent-bright)' }}>{doc.title} · {doc.version}</summary>
        <div style={{ maxHeight: 320, overflowY: 'auto', padding: 12, border: '1px solid var(--line)' }}>
          <LegalDocumentText document={doc} bundle={bundle} />
        </div>
      </details>
      <label style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: 13, lineHeight: 1.5 }}>
        <input type="checkbox" checked={checked[doc.kind] === true}
          onChange={(e) => setChecked((s) => ({ ...s, [doc.kind]: e.target.checked }))}
          style={{ marginTop: 3, flexShrink: 0 }} />
        <span>{doc.statement}</span>
      </label>
    </div>)}
  </div>;
}
